import React from "react";
import { Stack } from "expo-router/stack";

import { useSession } from "@/context/auth/useSession";
import ContentDetailsHeader from "@/screens/Content/Details/ContentDetailsHeader";
import ContentFeedHeader from "@/screens/Content/Feed/ContentFeedHeader";
import LoadingScreen from "@/screens/Loading/LoadingScreen";

export default function Layout(): React.JSX.Element {
  const { session } = useSession();

  if (session === null) {
    return <LoadingScreen />;
  }

  return (
    <Stack>
      <Stack.Screen
        name="home"
        options={{
          header: () => {
            return <ContentFeedHeader />;
          },
        }}
      />
      <Stack.Screen
        name="details"
        options={{
          header: () => {
            return <ContentDetailsHeader />;
          },
        }}
      />
    </Stack>
  );
}
